export { default } from 'shared/components/text'
